var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "fixed w-screen top-18 flex justify-end transition-all duration-500",
      style: {
        right: _vm.open ? "0vw" : "-100vw",
        height: "calc(100vh - 4.5rem)",
        zIndex: 51
      },
      attrs: { id: "new-intruction-panel" }
    },
    [
      _c("div", {
        staticClass: "h-full w-screen absolute left-0 top-0 -z-10",
        on: {
          click: function($event) {
            return _vm.$emit("close-panel")
          }
        }
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "h-full w-5 rounded-l-3xl flex-shrink-0 relative z-0",
        style: {
          background: "linear-gradient(180deg, #FFE4E8 0%, #9A8AC2 100%)"
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "h-full w-120 flex-shrink-0 flex flex-col bg-pure-white relative z-0"
        },
        [
          _c(
            "div",
            { staticClass: "py-4 px-6 flex flex-col gap-1" },
            [
              _c(
                "div",
                { staticClass: "flex items-center justify-between" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "relative rounded-full flex-shrink-0 min-h-6 px-3 flex items-center",
                      class: [
                        _vm.stage.is_discontinued
                          ? "bg-rose-200"
                          : _vm.stage.is_admitted
                          ? "bg-lime-200"
                          : "bg-cornflower-200"
                      ]
                    },
                    [
                      _c("BlTextSubtitle3", {
                        class: [
                          _vm.stage.is_discontinued
                            ? "text-rose-700"
                            : _vm.stage.is_admitted
                            ? "text-lime-700"
                            : "text-cornflower-800"
                        ],
                        attrs: { text: _vm.stage.name }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.open
                    ? _c("BlIcon", {
                        staticClass: "h-6 w-6",
                        attrs: {
                          icon: "close",
                          color: "slate-6",
                          clickable: ""
                        },
                        on: {
                          clicked: function($event) {
                            return _vm.$emit("close-panel")
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("BlTextTitle4", { attrs: { text: "Stage instructions" } })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "px-6 py-4 rounded-t-3xl bg-light-purple-300" },
            [
              _c("BlTextSubtitle2", {
                staticClass: "text-pure-white",
                attrs: { text: "Create new instruction" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "relative h-full flex flex-col justify-between overflow-y-auto"
            },
            [
              _c(
                "div",
                { staticClass: "py-5 px-6 flex flex-col gap-3" },
                [
                  _c(
                    "div",
                    { staticClass: "flex items-center gap-2" },
                    _vm._l(_vm.typeOptions, function(opt) {
                      return _c(
                        "div",
                        {
                          key: opt.value,
                          staticClass:
                            "h-7.5 px-2 flex items-center gap-2 rounded-full bg-lime-100 cursor-pointer border",
                          class: [
                            opt.value === _vm.typeInput
                              ? "border-lime-600"
                              : "border-lime-100"
                          ],
                          on: {
                            click: function($event) {
                              _vm.typeInput = opt.value
                            }
                          }
                        },
                        [
                          opt.value === "notes"
                            ? _c("BlIcon", {
                                staticClass: "h-4 w-4",
                                attrs: { icon: "paper-note", color: "lime-6" }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          opt.value === "todo"
                            ? _c("BlIcon", {
                                staticClass: "h-4 w-4",
                                attrs: { icon: "to-do", color: "lime-6" }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            staticClass: "text-lime-700",
                            attrs: { text: opt.label }
                          })
                        ],
                        1
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _vm.typeInput === "todo"
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "p-2 flex gap-2 bg-cornflower-200 rounded"
                        },
                        [
                          _c("BlIcon", {
                            staticClass: "h-4 w-4",
                            attrs: { icon: "lamp", color: "cornflower-8" }
                          }),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            staticClass: "text-cornflower-800",
                            attrs: {
                              text:
                                "When you set a to-do, you can assign people to complete the task when the prospect moves to this stage."
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("BlInputText", {
                    attrs: { input: _vm.titleInput },
                    on: { changed: _vm.inputHandler }
                  }),
                  _vm._v(" "),
                  _vm.open
                    ? _c(
                        "div",
                        { staticClass: "pb-px relative" },
                        [
                          _c("VueEditor", {
                            staticClass: "blum-editor",
                            attrs: {
                              "editor-toolbar": _vm.customToolbar,
                              placeholder: "Description"
                            },
                            model: {
                              value: _vm.descriptionInput,
                              callback: function($$v) {
                                _vm.descriptionInput = $$v
                              },
                              expression: "descriptionInput"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.uploads.length
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "p-2 flex flex-col gap-2 rounded bg-slate-200"
                        },
                        _vm._l(_vm.uploads, function(upload) {
                          return _c("BlFileHolder", {
                            key: upload.lastModified,
                            attrs: {
                              name: upload.name,
                              size: upload.size,
                              removeable: ""
                            },
                            on: {
                              "remove-handler": function($event) {
                                return _vm.onRemoveDoc(upload)
                              }
                            }
                          })
                        }),
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex items-center justify-between" },
                    [
                      _c("input", {
                        attrs: {
                          type: "file",
                          name: "new_upload_document_stage_" + _vm.stage.id,
                          id: "new_upload_document_stage_" + _vm.stage.id,
                          hidden: ""
                        },
                        on: { change: _vm.onAddDoc }
                      }),
                      _vm._v(" "),
                      _vm.open
                        ? _c("BlInputButton", {
                            attrs: {
                              type: "plain",
                              dense: "",
                              icon: "plus",
                              label: "Add document"
                            },
                            on: { clicked: _vm.openUpload }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.uploads.length
                        ? _c("BlTextBody2", {
                            attrs: {
                              text: _vm.uploads.length + " file(s) added"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "h-18 px-6 pt-4 sticky bottom-0 flex-shrink-0 bg-pure-white grid"
                },
                [
                  _c("BlInputButton", {
                    attrs: {
                      label: "Create",
                      disabled: _vm.isDisabledSubmit,
                      loading: _vm.submitLoading
                    },
                    on: { clicked: _vm.onCreate }
                  })
                ],
                1
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e372d972", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e372d972","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/salesPipeline/modal/NewInstructionStagePanel.vue
// module id = null
// module chunks = 